import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Projects from '../views/Projects.vue';
import Resources from '../views/Resources.vue';
import Admin from '../views/Admin.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/projects',
    name: 'Projects',
    get component() {
      if (window.localStorage.getItem('apollo-token')) {
        return Projects;
      }
      return Home;
    },
  },
  {
    path: '/resources',
    name: 'Resources',
    get component() {
      if (window.localStorage.getItem('apollo-token')) {
        return Resources;
      }
      return Home;
    },
  },
  {
    path: '/admin',
    name: 'Admin',
    get component() {
      const token = localStorage.getItem('apollo-token');
      let role = '';
      if (token) {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace('-', '+').replace('_', '/');
        role = JSON.parse(window.atob(base64)).role;
      }

      if (window.localStorage.getItem('apollo-token')) {
        if (role === 'Admin') {
          return Admin;
        }
        return Projects;
      }
      return Home;
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
